import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

const DEFAULT_LANG = 'TR';

@Injectable({
  providedIn: 'root'
})
export class DefaultHeadersInterceptor implements HttpInterceptor {
  constructor() {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let disableCache = false;
    if (/MSIE|Trident/.test(window.navigator.userAgent)) {
      disableCache = true;
    }
    if (disableCache) {
      request = request.clone({
        setHeaders: {
          'Cache-Control': 'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
          'Pragma': 'no-cache',
          'Expires': '0'
        }
      });
    } else {
      request = request.clone({
        setHeaders: {
          'Accept-Language': DEFAULT_LANG
        },
        withCredentials: true
      });
    }

    return next.handle(request);
  }
}
